/*
 * Copyright (c) 2020, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
*/

import { NotificationReducer, Notificationtype } from '../../data/interfaces';
import { SUCCESS, ERROR, NotificationAction, RESET } from '../types/notification';

const initialState: NotificationReducer = {
    type: Notificationtype.default,
    message: ''
}

const notificationReducer = (state = initialState, action: NotificationAction) => {
    switch (action.type) {
        case SUCCESS:
            return {
                type: Notificationtype.success,
                message: action.message
            }
        case ERROR:
            return {
                type: Notificationtype.error,
                message: action.message
            }
        case RESET:
            return {
                type: Notificationtype.info,
                message: ""
            }
        default:
            return state
    }
}

export default notificationReducer;
